module.exports = __webpack_public_path__ + "img/activity-img.d3eaf735.png";